import { ClientDailyBalance } from '@/services/client-daily-balance.service';

/** Значення для заголовка дня; `null` - нема доступу до цієї частини, не показуємо. */
export interface DayBalanceView {
  carbs: number | null;
  fat: number | null;
  protein: number | null;
  kcal: number | null;
  /** Витрата енергії, додатне число; показується зі знаком мінус. */
  burned: number | null;
}

const round = (value: number | null, digits = 0): number | null => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  const factor = 10 ** digits;
  return Math.round(Number(value) * factor) / factor;
};

/** Баланс дня у вигляді для показу; null - за день нічого не спожито й не витрачено. */
export function toDayBalanceView(balance: ClientDailyBalance | undefined): DayBalanceView | null {
  if (!balance) return null;
  const view: DayBalanceView = {
    carbs: round(balance.carbsG),
    fat: round(balance.fatG),
    protein: round(balance.proteinG),
    kcal: round(balance.caloriesConsumed),
    burned: round(balance.caloriesBurned, 1),
  };
  const hasData = Object.values(view).some(value => value !== null && value !== 0);
  return hasData ? view : null;
}

export function indexBalanceByDate(balances: ClientDailyBalance[]): Record<string, ClientDailyBalance> {
  return Object.fromEntries(balances.map(balance => [balance.date.slice(0, 10), balance]));
}
